import { t } from '@lingui/core/macro'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/patienten/$id/_edit/_documents/_forms/stammblatt')({
  component: RouteComponent,

  loader: () => ({
    breadcrumb: {
      label: t`Stammblätter`,
      to: '/patienten/$id/stammblatt',
      params: { id: 'patientId' },
    },
  }),
})

function RouteComponent() {
  return <Outlet />
}
